import React from "react";

// Mui Styles
import { ThemeProvider } from "@mui/material/styles";
import { StyledPaper } from "@/styles/mui/globalStyles";
import { TableListTheme } from "@/styles/mui/tableListTheme";

// Navigate
import { useNavigate } from "react-router-dom";

// Components
import Layout from "@/components/layout";
import Title from "@/components/title";
import DataTable from "@/components/dataTable";
import { CSVLink } from "react-csv";
import IconButton from "@mui/material/IconButton";
import DownloadIcon from "@mui/icons-material/Download";
import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload";

// Fetch
import { getAllPromoter } from "@/fetch/fetchStaff";
import { getSohList, editStockOnHandList } from "@/fetch/fetchStock";
import { useCurrentAction } from "@/hooks/user";

// Config
import { StockOnHandTableColumn } from "@/config/tableColumnConfig";
import moment from "moment";
const StockOnHandManagePage = (props) => {
  const { open, setOpen } = props;
  const actions = useCurrentAction();

  const headers = [
    { label: "id", key: "id" },
    { label: "full_name", key: "full_name" },
    { label: "staff_code", key: "staff_code" },
    { label: "user_id", key: "user_id" },
    { label: "giveaway_master_item_id", key: "giveaway_master_item_id" },
    { label: "m18_product_code", key: "m18_product_code" },
    { label: "item_name", key: "item_name" },
    { label: "stockonhand_qty", key: "stockonhand_qty" },
    { label: "adjust_qty", key: "adjust_qty" },
    { label: "remark", key: "remark" },
  ];
  // Navigate
  const navigate = useNavigate();
  // States
  const [staffData, setStaffData] = React.useState([]);
  const [snackMessage, setSnackMessage] = React.useState("");
  const [snackOpen, setSnackOpen] = React.useState(false);
  const [sohListData, setSohListData] = React.useState([]);
  const [dataTableLoading, setDataTableLoading] = React.useState(false);

  const fileReader = new FileReader();
  const onCellClick = (data) => {
    if (data.field === "__check__") return;
    else navigate(`${data.id}`);
  };

  // Fetch
  const fetchAll = async () => {
    try {
      setDataTableLoading(true);
      await getAllPromoter().then((data) => {
        if (data && data.results) {
          let tempArr = [...data.data];
          for (let i = 0; i < tempArr.length; i++) {
            delete tempArr[i].shop_permission;
          }
          setStaffData(tempArr);
        }
      });
      await getSohList().then((data) => {
        if (data && data.results) {
          setSohListData(data.data);
        }
      });
    } catch (error) {
    } finally {
      setDataTableLoading(false);
    }
  };
  const handleOnChangeUpload = (e) => {
    e.preventDefault();

    const file = e.target.files[0];

    if (file) {
      fileReader.onload = async function (event) {
        const text = event.target.result;

        const quoteChar = '"';
        const delimiter = ",";

        const regex = new RegExp(
          `\\s*(${quoteChar})?(.*?)\\1\\s*(?:${delimiter}|$)`,
          "gs"
        );

        const match = (line) =>
          [...line.matchAll(regex)]
            .map((m) => m[2]) // we only want the second capture group
            .slice(0, -1); // cut off blank match at the end

        var lines = text.split("\n");
        var result = [];

        // Read first row and display first column
        // var readVersion = lines[0].split(",");
        // var version = readVersion[0];

        var headers = match(lines.shift());
        // var headers = lines[1].split(",");
        // for (let i = 0; i < headers.length; i++) {
        //   headers[i] = headers[i].replace(`\r`, "");
        // }

        // Rows, skip 0
        for (var i = 0; i < lines.length; i++) {
          var obj = {};
          var currentline = match(lines[i]);

          // Columns
          for (var j = 0; j < headers.length; j++) {
            if (currentline[j] !== "" && currentline[j] !== undefined) {
              obj[headers[j]] = currentline[j];
            }
          }
          if (Number(obj.adjust_qty > 0) || Number(obj.adjust_qty < 0)) {
            result.push({ ...obj, reason_id: "999" });
          }
        }

        // Output
        await editStockOnHandList(result).then((data) => {
          if (data.results) {
            setSnackMessage(`上傳成功`);
          } else {
            setSnackMessage(`上傳失敗`);
          }
          setSnackOpen(true);
          setTimeout(() => {
            setSnackOpen(false);
          }, 3000);
        });
        fetchAll();
      };

      fileReader.readAsText(file);
    }
    e.target.value = null;
  };
  React.useEffect(() => {
    fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout
      header="StaffManagePage"
      snackOpen={snackOpen}
      snackClose={() => setSnackOpen(false)}
      snackMessage={snackMessage}
      selectedIndex={21}
      open={open}
      setOpen={setOpen}
    >
      <Title
        history={() => navigate(-1)}
        title="倉存管理"
        children={
          <div>
            {actions?.download && (
              <CSVLink
                data={sohListData}
                filename={`stock List - ${moment().format("YYYY-MM-DD")}`}
                headers={headers}
              >
                <IconButton component="label">
                  <DownloadIcon />
                </IconButton>
              </CSVLink>
            )}
            {actions?.update && (
              <IconButton component="label">
                <DriveFolderUploadIcon />
                <input
                  hidden
                  type={"file"}
                  id={"csvFileInput"}
                  accept={".csv"}
                  onChange={handleOnChangeUpload}
                />
              </IconButton>
            )}
          </div>
        }
      />
      <StyledPaper page={"yes"}>
        <ThemeProvider theme={TableListTheme}>
          <DataTable
            loading={dataTableLoading}
            rows={staffData}
            columns={StockOnHandTableColumn}
            onCellClick={(params) => onCellClick(params)}
            checkboxSelection={false}
            initialState={{
              sorting: {
                sortModel: [{ field: "staff_code", sort: "asc" }],
              },
            }}
          />
        </ThemeProvider>
      </StyledPaper>
    </Layout>
  );
};

export default StockOnHandManagePage;
